import apiClient from "../vue/http/axios";


async function getCompanyInfo(id) {
  return apiClient.get(`/companies/${id}`);
}

export default {
  getCompanyInfo,
}